import fb_editorial from "../../assets/images/fb-editorial.svg";
import twitter_editorial from "../../assets/images/twitter-editorial.svg";
import transparencia from "../../assets/images/transparencia.svg";
import obligaciones_transparencia from "../../assets/images/obligaciones_transparencia.svg";
import { Link } from "react-router-dom";

export default function Transparencia(){
    return(        
        <div className="container-fluid back_white mt-4 mb-2">
            <div className="row">
                <div className="col-12 d-block d-md-flex justify-content-evenly mb-4 text-center">
                    <a href="https://twitter.com/EditorialTEPJF" target="_blank" rel="noreferrer" className="text-center">
                    <img src={twitter_editorial} alt="facebook editorial" className="img-fluid icon_media_footer"/>
                    </a>
                    <Link to={{ pathname: "https://www.te.gob.mx/cendoc/" }} target="_blank">
                        <button className="btn_footer mt-3 mt-sm-0 p-3">Sitios de interés  </button>
                    </Link>
                    <a href="https://www.facebook.com/EDITORIALDELTEPJF/" target="_blank" rel="noreferrer">
                        <img src={fb_editorial} alt="facebook editorial" className="img-fluid icon_media_footer mt-3 mt-md-0"/>
                    </a>
                </div>
            </div>
            <div className="row pt-5 justify-content-center h-100">
                <div className="col-12 col-sm-5 col-lg-3 text-center ml-1 ">
                    <a href="https://www.plataformadetransparencia.org.mx/" target="_blank" rel="noreferrer">
                        <img src={transparencia} alt="plataforma nacional de transparencia" height="60px"/>
                    </a>
                </div>
                <div className="col-12 col-sm-5 col-lg-3 text-center mr-1 mt-3 mt-sm-0 mb-5">
                    <a href="https://consultapublicamx.inai.org.mx/vut-web/faces/view/consultaPublica.xhtml?idEntidad=MzM=&idSujetoObligado=MzA2#inicio"
                        target="_blank" rel="noreferrer">
                        <img src={obligaciones_transparencia} alt="Consulta nuestras obligaciones de transparencia (LGT artículo 64)" height="60px" />
                    </a>
                </div>
            </div>
        </div>
        
    );
}